import type { ReactNode } from 'react'
import { cn } from 'cn'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next/pages'
import Link from 'next/link'

type SideMenuItemProps = {
  icon: ReactNode
  name: ParseKeys
  href: string
  className?: string
}

export function SideMenuItem({
  icon,
  name,
  href,
  className,
  ...rest
}: SideMenuItemProps): ReactNode {
  const { t } = useTranslation()

  return (
    <Link
      href={href}
      className={cn(
        'flex items-center gap-3 rounded-md px-2 py-2 text-base outline-none hover:bg-bg-tertiary focus-visible:focus-ring-primary',
        className,
      )}
      {...rest}
    >
      <div className="flex size-6 shrink-0 items-center justify-center [&>svg]:size-full">
        {icon}
      </div>
      {t(name)}
    </Link>
  )
}
